import { UserRole } from '@40seas/entities/users';
import { useUser } from '../setup/userContext';

export const isGuestRole = (role: UserRole): boolean => {
    return [UserRole.Guest, UserRole.GuestCreditLine, UserRole.GuestLanding].includes(role);
};

export const useIsGuest = () => {
    const user = useUser();
    return isGuestRole(user?.role as UserRole);
};
